import { Text, View } from '@react-pdf/renderer'
import dayjs from 'dayjs'
import React from 'react'
import { OrganizationContactContextValue } from '../../../hooks/use-orgazination-contact'
import { formatABN, formatACN } from '@reapitform/utils'
import { PdfStyle } from '@reapitform/common-ui'
import { ActivityLogPDFStyle } from './style'

export const AgreementActivityLogFooter: React.FC<{ organizationData: OrganizationContactContextValue }> = ({
  organizationData,
}) => {
  return (
    <View fixed style={ActivityLogPDFStyle.footer}>
      <View>
        <Text>Generated by Reapit Forms on {dayjs().format('dddd, D MMMM YYYY, H:mm A')}</Text>
        <Text>
          <Text style={PdfStyle.bold}>{organizationData?.businessName ?? '-'} </Text>
          ABN {organizationData?.abn ? formatABN(organizationData?.abn) : 'n/a'} | ACN{' '}
          {organizationData?.acn ? formatACN(organizationData.acn) : 'n/a'}
        </Text>
      </View>
      <Text render={(props) => `Page ${props.pageNumber} of ${props.totalPages}`} />
    </View>
  )
}
